import { config } from "../config";

export type ChannelBanner = {
  id: number;
  title: string;
  placement: string;
  imageUrl: string;
  width?: number | null;
  height?: number | null;
  clickUrl?: string;
  newTab?: boolean;
};

export async function loadChannelBanner(): Promise<ChannelBanner | null> {
  if (!config.bannerUrl) return null;

  try {
    const res = await fetch(config.bannerUrl, {
      cache: "no-store",
      headers: { accept: "application/json" },
    });
    if (!res.ok) return null;
    const data = await res.json() as { banner?: Partial<ChannelBanner> | null };
    const banner = data.banner;
    if (!banner || typeof banner.imageUrl !== "string" || !banner.imageUrl) return null;
    return {
      id: Number(banner.id ?? 0),
      title: typeof banner.title === "string" ? banner.title : "Advertisement",
      placement: typeof banner.placement === "string" ? banner.placement : "below",
      imageUrl: banner.imageUrl,
      width: typeof banner.width === "number" ? banner.width : null,
      height: typeof banner.height === "number" ? banner.height : null,
      clickUrl: typeof banner.clickUrl === "string" ? banner.clickUrl : "",
      newTab: Boolean(banner.newTab),
    };
  } catch {
    return null;
  }
}
